<nav id="detailsnav" class="nhsuk-contents-list scwcsu" role="navigation" aria-label="Child details sections">
  <ul class="nhsuk-contents-list__list">
    <li aria-current="page" *ngIf="shouldDisplayNavItem('demographicInformation')">
      <a
        class="list-item-link"
        [ngClass]="{
          'active-link': isUrlMatch([
            'demographic',
            'birth-details',
            'related-parties',
            'language',
            'contact',
            'details',
            'school',
            'names',
            'details',
            'flags',
            'health-visitor',
          ]),
        }"
        [routerLink]="this.url + '/demographic'"
        onclick="this.blur()"
      >
        <svg
          class="nhsuk-icon nhsuk-icon__chevron-right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
          ></path>
        </svg>
        Demographic information
      </a>

      <ul
        *ngIf="isUrlMatch(['demographic', 'birth-details', 'related-parties', 'language', 'contact', 'details', 'school', 'names', 'details', 'flags', 'health-visitor'])"
        class="nhsuk-contents-list__list ml-24"
      >
        <li>
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['demographic']) }"
            [routerLink]="this.url + '/demographic'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            Demographic
          </a>
        </li>
        <li>
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['birth-details']) }"
            [routerLink]="this.url + '/birth-details'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            Birth Details
          </a>
        </li>
        <li>
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['related-parties']) }"
            [routerLink]="this.url + '/related-parties'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            Related Parties
          </a>
        </li>
        <li>
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['language']) }"
            [routerLink]="this.url + '/language'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            Language Details
          </a>
        </li>
        <li>
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['contact']) }"
            [routerLink]="this.url + '/contact'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            Contact Details
          </a>
        </li>
        <li>
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['health-visitor']) }"
            [routerLink]="this.url + '/health-visitor'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            Health Visitor
          </a>
        </li>
        <li>
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['school']) }"
            [routerLink]="this.url + '/school'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            School Details
          </a>
        </li>
        <li>
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['names']) }"
            [routerLink]="this.url + '/names'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            Other Names
          </a>
        </li>
        <li>
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['details']) }"
            [routerLink]="this.url + '/details'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            Other Details
          </a>
        </li>
        <li class="lastSubLi">
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['flags']) }"
            [routerLink]="this.url + '/flags'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            Flags
          </a>
        </li>
      </ul>
    </li>

    <li *ngIf="shouldDisplayNavItem('newbornBloodSpotScreening')">
      <a
        class="list-item-link"
        [ngClass]="{ 'active-link': isUrlMatch(['blood-spot-screening', 'blood-spot-screening-test']) }"
        [routerLink]="this.url + '/blood-spot-screening'"
        onclick="this.blur()"
      >
        <svg
          class="nhsuk-icon nhsuk-icon__chevron-right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
          ></path>
        </svg>
        Newborn Blood Spot Screening
      </a>
    </li>

    <li *ngIf="shouldDisplayNavItem('newbornHearingScreening')">
      <a
        class="list-item-link"
        [ngClass]="{ 'active-link': isUrlMatch(['hearing-screening']) }"
        [routerLink]="this.url + '/hearing-screening'"
        onclick="this.blur()"
      >
        <svg
          class="nhsuk-icon nhsuk-icon__chevron-right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
          ></path>
        </svg>
        Newborn Hearing Screening
      </a>
    </li>

    <li *ngIf="shouldDisplayNavItem('examination')">
      <a
        class="list-item-link"
        [ngClass]="{ 'active-link': isUrlMatch(['examinations']) }"
        [routerLink]="this.url + '/examinations'"
        onclick="this.blur()"
      >
        <svg
          class="nhsuk-icon nhsuk-icon__chevron-right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
          ></path>
        </svg>
        Examination
      </a>
    </li>
    <li aria-current="page" *ngIf="shouldDisplayNavItem('demographicInformation')">
      <a
        class="list-item-link"
        [ngClass]="{
          'active-link': isUrlMatch([
            'childhood-vaccinations',
            'vaccinations',
            'refusal-suspension',
            'reason-vaccine-not-given',
            'vaccine-status',
          ]),
        }"
        [routerLink]="this.url + '/vaccinations'"
        onclick="this.blur()"
      >
        <svg
          class="nhsuk-icon nhsuk-icon__chevron-right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
          ></path>
        </svg>
        Childhood Vaccination
      </a>
      <ul
        *ngIf="
          isUrlMatch([
            'childhood-vaccinations',
            'vaccinations',
            'refusal-suspension',
            'reason-vaccine-not-given',
            'vaccine-status',
          ])
        "
        class="nhsuk-contents-list__list ml-24"
      >
        <li>
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['vaccinations']) }"
            [routerLink]="this.url + '/vaccinations'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            Vaccination History
          </a>
        </li>
        <li>
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['refusal-suspension']) }"
            [routerLink]="this.url + '/refusal-suspension'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            Vaccination Consent & Suspensions
          </a>
        </li>
        <li>
          <a
            class="list-item-link"
            [ngClass]="{ 'active-link': isUrlMatch(['vaccine-status']) }"
            [routerLink]="this.url + '/vaccine-status'"
            onclick="this.blur()"
          >
            <svg
              class="nhsuk-icon nhsuk-icon__chevron-right"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
              ></path>
            </svg>
            Vaccine Status
          </a>
        </li>
      </ul>
    </li>
    <li *ngIf="shouldDisplayNavItem('bcgProgramme')">
      <a
        class="list-item-link"
        [ngClass]="{ 'active-link': isUrlMatch(['bcg']) }"
        [routerLink]="this.url + '/bcg'"
        onclick="this.blur()"
      >
        <svg
          class="nhsuk-icon nhsuk-icon__chevron-right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
          ></path>
        </svg>
        BCG Programme
      </a>
    </li>
    <li *ngIf="shouldDisplayNavItem('neoNatalHepb')">
      <a
        class="list-item-link"
        [ngClass]="{ 'active-link': isUrlMatch(['neo-natal-hepb']) }"
        [routerLink]="this.url + '/neo-natal-hepb'"
        onclick="this.blur()"
      >
        <svg
          class="nhsuk-icon nhsuk-icon__chevron-right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
          ></path>
        </svg>
        Neo-natal Selective HepB Pathway
      </a>
    </li>

    <ng-container *ngIf="demographic$ | async as demographic">
      <li *ngIf="demographic.dateOfDeath">
        <a
          class="list-item-link"
          [ngClass]="{ 'active-link': isUrlMatch(['death']) }"
          [routerLink]="this.url + '/death'"
          onclick="this.blur()"
        >
          <svg
            class="nhsuk-icon nhsuk-icon__chevron-right"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
            ></path>
          </svg>
          Death Details
        </a>
      </li>
    </ng-container>
  </ul>
</nav>
